import Box from '@mui/material/Box';

/**
 * Vertical spacer that offsets page content below the fixed AppBar. Uses MUI's
 * `theme.mixins.toolbar`, so its height tracks the AppBar across breakpoints
 * (56px on mobile, 64px on sm+, and the landscape variants) — unlike the old
 * hardcoded `h-16` (64px), which left an 8px gap on phones.
 */
const AppBarSpacer = () => <Box sx={(theme) => theme.mixins.toolbar} />;

export default AppBarSpacer;
